import { convertDateToTimeZone } from 'infrastructure/functions';
import StatusCell from 'components/molecules/rpm-overview-table/components/reading-table/status-cell';
import ReadingCell from 'components/molecules/rpm-overview-table/components/reading-table/reading-cell';
import ThresholdCell from 'components/molecules/rpm-overview-table/components/reading-table/threshold-cell';
import DateCell from 'components/molecules/rpm-overview-table/components/reading-table/date-cell';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { IRpmPatientFormActivity } from '../types';
import type { FC } from 'react';

interface ReadingTypeListProps {
  readingsByType: IRpmPatientFormActivity[] | undefined;
}

const ReadingTypeList: FC<ReadingTypeListProps> = ({ readingsByType }) => {
  const { t } = useTranslation();

  return readingsByType?.map((reading, idx) => {
    const readingDate = new Date(parseInt(reading.createdAt));
    const patientTimeDate = convertDateToTimeZone(
      new Date(parseInt(reading.createdAt)),
      reading.patient.timezone,
    );
    const ordinalNumber = idx + 1;

    return (
      <div
        className={s['reading-type-list-item-wrapper']}
        key={reading.dateTime}
      >
        <div className={s['reading-type-list-header']}>
          <div className={s['reading-list-date']}>
            <b>#{ordinalNumber} </b>
            <DateCell date={readingDate} />
          </div>
          <div className={s['reading-type-list-date']}>
            <span>{t('labels.patientTime')}: </span>
            <DateCell date={patientTimeDate} />
          </div>
        </div>
        <div className={s['reading-type-list-body']}>
          <div className={s['reading-type-list-reading']}>
            <StatusCell
              globalStatus={reading.globalStatus}
              thresholds={reading.patient.threshold}
              thresholdName={reading.thresholdName}
              mightBeErroneousReason={reading.mightBeErroneousReason}
              isRecovered={reading.isRecovered}
              receivedTime={reading.receivedTime}
              readingTime={reading.dateTime}
              timezone={reading.patient.timezone}
              readingType={reading.readingType}
            />
            <ReadingCell
              values={reading.value}
              statuses={reading.statuses}
              readingType={reading.readingType}
            />
          </div>
          <div className={s['reading-type-list-threshold']}>
            <ThresholdCell
              values={reading.value}
              readingType={reading.readingType}
              thresholds={reading.patient.threshold}
              statuses={reading.statuses}
              globalStatus={reading.globalStatus}
              thresholdName={reading.thresholdName}
            />
          </div>
        </div>
      </div>
    );
  });
};

export default ReadingTypeList;
